import { render, staticRenderFns } from "./ModalDeparaNew.vue?vue&type=template&id=444dbc94&"
import script from "./ModalDeparaNew.vue?vue&type=script&lang=js&"
export * from "./ModalDeparaNew.vue?vue&type=script&lang=js&"
import style0 from "./ModalDeparaNew.vue?vue&type=style&index=0&id=444dbc94&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports